import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const COMITE_EJECUTIVO = [
  {
    id: 1,
    role: "Presidente",
    first_name: "Edgardo Camilo",
    last_name: "Mañez",
  },
  {
    id: 2,
    role: "Vicepresidente Primero",
    first_name: "Héctor Fabián",
    last_name: "Zucchini",
  },
  {
    id: 3,
    role: "Vicepresidente Segundo",
    first_name: "Gustavo Adrián",
    last_name: "Ciccarelli",
  },
  {
    id: 4,
    role: "Vicepresidente Tercero",
    first_name: "Walter José",
    last_name: "Sulier",
  },
  {
    id: 5,
    role: "Secretario",
    first_name: "Anibal Alberto",
    last_name: "Rodriguez",
  },
  {
    id: 6,
    role: "Prosecretario",
    first_name: "Carlos Alberto",
    last_name: "Gariboglio",
  },
  {
    id: 7,
    role: "Tesorero",
    first_name: "Marcelo Claudio",
    last_name: "Blenda",
  },
  {
    id: 8,
    role: "Protesorero",
    first_name: "Luciano",
    last_name: "Beltriti",
  },
];

const TRIBUNAL_DE_CUENTAS = [
  {
    id: 1,
    role: "Presidente",
    first_name: "Ricardo",
    last_name: "Magallanes",
  },
  {
    id: 2,
    role: "Miembro Titular",
    first_name: "Gianfranco",
    last_name: "Bernardi",
  },
  {
    id: 3,
    role: "Miembro Titular",
    first_name: "Gabriel Fabian",
    last_name: "Perez",
  },
  {
    id: 4,
    role: "Miembro Titular",
    first_name: "Ramon Antonio",
    last_name: "Mazza",
  },
  // {
  //   id: 5,
  //   role: 'Miembro Suplente',
  //   first_name: 'Gabriel Alberto',
  //   last_name: 'Pagliaricci',
  // },
  // {
  //   id: 6,
  //   role: 'Miembro Suplente',
  //   first_name: 'Javier',
  //   last_name: 'Pereyra',
  // },
];

const TRIBUNAL_DE_DISCIPLINA = [
  {
    id: 1,
    role: "Presidente",
    first_name: "Luis Eduardo",
    last_name: "Leal Calquin",
  },
  {
    id: 2,
    role: "Miembro Titular",
    first_name: "Armando Eduardo",
    last_name: "Loeffel",
  },
  {
    id: 3,
    role: "Miembro Titular",
    first_name: "Sergio Daniel",
    last_name: "Irastorza",
  },
  {
    id: 4,
    role: "Miembro Titular",
    first_name: "Luis Eduardo",
    last_name: "Quevedo",
  },
  {
    id: 5,
    role: "Miembro Titular",
    first_name: "Alberto Vicente",
    last_name: "Marmara",
  },
  // {
  //   id: 6,
  //   role: 'Miembro Suplente',
  //   first_name: 'Javier',
  //   last_name: 'Pereyra',
  // },
];

function Autoridades() {
  return (
    <>
      <button
        onClick={() => window.history.back()}
        className="autoridades__backBtn"
      >
        <ArrowBackIosNewIcon />
      </button>
      <div className="autoridades">
        <h1 className="autoridades__title">Autoridades</h1>
        <main className="autoridades__main">
          <section className="autoridades__section">
            <h1 className="autoridades__sectionTitle">COMITÉ EJECUTIVO</h1>
            <hr style={{ width: "100%", marginBottom: "30px" }} />
            {COMITE_EJECUTIVO.map((person) => (
              <article
                key={`personCE-${person.id}`}
                className="autoridades__role"
              >
                <h2 className="autoridades__roleName">{person.role}</h2>
                <div className="autoridades__staff">
                  <h2 className="autoridades__staffName">{`${person.last_name}, ${person.first_name}`}</h2>
                </div>
              </article>
            ))}
          </section>
          <section className="autoridades__section">
            <h1 className="autoridades__sectionTitle">TRIBUNAL DE CUENTAS</h1>
            <hr style={{ width: "100%", marginBottom: "30px" }} />
            {TRIBUNAL_DE_CUENTAS.map((person) => (
              <article
                key={`personTC-${person.id}`}
                className="autoridades__role"
              >
                <h2 className="autoridades__roleName">{person.role}</h2>
                <div className="autoridades__staff">
                  <h2 className="autoridades__staffName">{`${person.last_name}, ${person.first_name}`}</h2>
                </div>
              </article>
            ))}
          </section>
          <section className="autoridades__section">
            <h1 className="autoridades__sectionTitle">
              TRIBUNAL DE DISCIPLINA
            </h1>
            <hr style={{ width: "100%", marginBottom: "30px" }} />
            {TRIBUNAL_DE_DISCIPLINA.map((person) => (
              <article
                key={`personTC-${person.id}`}
                className="autoridades__role"
              >
                <h2 className="autoridades__roleName">{person.role}</h2>
                <div className="autoridades__staff">
                  <h2 className="autoridades__staffName">{`${person.last_name}, ${person.first_name}`}</h2>
                </div>
              </article>
            ))}
          </section>
        </main>
      </div>
    </>
  );
}

export default Autoridades;
